// extracted by mini-css-extract-plugin
export default {"row":"StatusData_row__AIZ0e","rowHeader":"StatusData_rowHeader__ZbXA1","rowValue":"StatusData_rowValue__681Zj"};